import { useStripe } from '@stripe/react-stripe-js';
import { SetupIntent } from '@stripe/stripe-js';
import { useState } from 'react';

import { billingApi } from 'apis/billing';

export type UseConfirmPaymentMethodResult = [
  (id: string) => Promise<SetupIntent | undefined>,
  { isLoading: boolean },
];

/**
 * UseConfirmPaymentMethod is a hook that gets a Stripe setup intent and uses
 * the setupIntent to confirm a payment method in stripe.
 *
 * This is a flow for authorizing using 3ds2.
 */
export const useConfirmPaymentMethod = (): UseConfirmPaymentMethodResult => {
  const stripe = useStripe();
  const [isLoading, setIsLoading] = useState(false);
  const [createSetupIntent] = billingApi.useCreateSetupIntentMutation();

  const confirmPaymentMethod = async (
    /** Payment method id */
    id: string,
  ) => {
    if (!stripe) return;

    setIsLoading(true);
    let caughtError;

    try {
      const { data: creatSetupIntentData } = await createSetupIntent().unwrap();

      const { setupIntent, error: confirmCardSetupError } =
        await stripe.confirmCardSetup(creatSetupIntentData.client_secret, {
          payment_method: id,
        });

      setIsLoading(false);

      if (confirmCardSetupError) {
        throw confirmCardSetupError;
      }

      return setupIntent;
    } catch (error: unknown) {
      setIsLoading(false);
      caughtError = error;
    }

    if (caughtError) {
      throw caughtError;
    }
  };

  return [confirmPaymentMethod, { isLoading: isLoading }];
};
